import React from "react";
import Header from "../../Components/HeaderAdmin/Header";
import { Link } from "react-router-dom";

function StaffEdit() {
    return (
        <>

            <div className="main-page-body-content-header">
                <Header />
            </div>
            <div className="dashboard-container d-flex">
                <div className="main-container">
                    <div className="main-page-body-content">
                        <div className="main-page-body-content-body">
                            <div className="main-page-body-content-body-container">
                                <div className="container-fluid">
                                    <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                        <h3>Edit Staff</h3>
                                    </div>
                                    <div className="dashboard-sec">
                                        <div className="container-fulid">
                                            <div className="form-box-section mt-4">
                                                <div className="form-box-inner">
                                                    <div className="form-item">
                                                        <div className="form-group custom-form-group">
                                                            <div className="col-md-6">
                                                                <label className="dashboard-form-lable">Name</label>
                                                            </div>
                                                            <input type="text"
                                                                className="form-control dashboard-input-box-1 me-1"
                                                                placeholder="First"
                                                                required
                                                            />
                                                            <input type="text"
                                                                className="form-control dashboard-input-box-1"
                                                                required
                                                                placeholder="Last"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="form-item">
                                                        <div className="form-group custom-form-group">
                                                            <div className="col-md-4">
                                                                <label className="dashboard-form-lable">Email</label>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <input type="email"
                                                                    required
                                                                    className='form-control dashboard-input-box-2'
                                                                    placeholder="Email Address"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="form-item">
                                                        <div className="form-group custom-form-group">
                                                            <div className="col-md-4">
                                                                <label className="dashboard-form-lable">Phone</label>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <input type="text" placeholder="Phone Number " required className="form-control dashboard-input-box"/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="form-item">
                                                        <div className="form-group custom-form-group">
                                                            <div className="col-md-4">
                                                                <label className="dashboard-form-lable">Password</label>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <input type="password" placeholder="Password"
                                                                    required
                                                                    className="form-control dashboard-input-box"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="form-item">
                                                        <div className="form-group custom-form-group">
                                                            <div className="col-md-4">
                                                                <label className="dashboard-form-lable">Confirm Password</label>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <input type="password" className="form-control dashboard-input-box" placeholder="Confirm Password" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="form-item">
                                                        <div className="form-group custom-form-group">
                                                            <div className="col-md-4">
                                                                <label className="dashboard-form-lable">Role</label>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <select className="form-control dashboard-input-box">
                                                                    <option >Select Role</option>
                                                                    <option >Admin</option>
                                                                    <option>Staff</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="form-item">
                                                        <div className="form-group custom-form-group">
                                                            <div className="col-md-4">
                                                                <label className="dashboard-form-lable" >Facebook Link</label>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <input type="text" className="form-control dashboard-input-box" placeholder="Facebook Link"/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="form-item">
                                                        <div className="form-group custom-form-group">
                                                            <div className="col-md-4">
                                                                <label className="dashboard-form-lable">Instagram Link</label>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <input type="text" className="form-control dashboard-input-box" placeholder="Instagram Link" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="form-item">
                                                        <div className="form-group custom-form-group">
                                                            <div className="col-md-4">
                                                                <label className="dashboard-form-lable">Twitter Link</label>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <input type="text" className="form-control dashboard-input-box" placeholder="Twitter Link" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="sec-btn-group mt-4">
                                                <Link to="/staff">
                                                    <button className="btn btn-cancel">Exit without saving</button>
                                                </Link>
                                                <Link to="/edit-staff">
                                                    <button className="btn btn-save" type="submit">Save new Staff</button>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default StaffEdit;